import React from 'react';
import { Grid } from '@material-ui/core';
import { SummaryCard } from './SummaryCard';
import { SummaryCardData } from './types';

export interface SummaryCardsProps {
  cards: SummaryCardData[];
  columns?: 2 | 3 | 4;
  onCardClick?: (id: string) => void;
  className?: string;
}

export const SummaryCards: React.FC<SummaryCardsProps> = ({
  cards,
  columns = 4,
  onCardClick,
  className = '',
}) => {
  const gridSize = 12 / columns as 3 | 4 | 6;

  return (
    <Grid container spacing={3} className={className}>
      {(cards ?? []).map((card) => (
        <Grid item xs={12} sm={6} md={gridSize} key={card.id}>
          <SummaryCard
            {...card}
            onClick={onCardClick}
          />
        </Grid>
      ))}
    </Grid>
  );
};
